module.exports = __webpack_public_path__ + "static/media/teamPlans.3274b8dc.png";